import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { ButtonSetting } from "@/models/api/ButtonSetting";
import { BUTTON_NAMES } from "@/static/buttonNames";
import { KSEF_STATUS_ENUM } from "@/static/ksefStatusEnum";

export class RelatedDocument {
  @IsString()
  @Expose()
  id!: string;

  @IsString()
  @Expose()
  documentNumber!: string;

  @IsNumber()
  @Expose()
  documentTypeId!: number;

  @IsString()
  @Expose()
  contractorName!: string;

  @IsString()
  @Expose()
  sellerName!: string;

  @IsString()
  @Expose()
  issueDate!: string;

  @IsString()
  @Expose()
  saleDate!: string;

  @IsOptional()
  @IsString()
  @Expose()
  tin!: string;

  @IsBoolean()
  @Expose()
  isCancelled!: boolean;

  @IsNumber()
  @Expose()
  recordStampId!: number;

  @IsNumber()
  @Expose()
  stateToSend!: number;

  @Type(() => ButtonSetting)
  @ValidateNested()
  @Expose()
  buttonSettings!: Map<BUTTON_NAMES, ButtonSetting>;
}

export class DocumentsListItem {
  @IsString()
  @Expose()
  id!: string;
  @IsNumber()
  @Expose()
  documentTypeId!: number;
  @IsOptional()
  @IsString()
  @Expose()
  orderId!: string | null;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsOptional()
  @IsString()
  @Expose()
  ksefNumber!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  ksefAcquisitionDate!: string | null;
  @IsEnum(KSEF_STATUS_ENUM)
  @Expose()
  ksefStatus!: KSEF_STATUS_ENUM;
  @IsString()
  @Expose()
  contractor!: string;
  @IsString()
  @Expose()
  seller!: string;
  @IsOptional()
  @IsString()
  @Expose()
  tin!: string;
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @Expose()
  issueDate!: string;
  @IsString()
  @Expose()
  saleDate!: string;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsNumber()
  @Expose()
  leftToPay!: number;
  @IsNumber()
  @Expose()
  leftToPayInCurrency!: number;
  @IsString()
  @Expose()
  createdAt!: string;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsNumber()
  @Expose()
  contractorId!: number;
  @IsBoolean()
  @Expose()
  canEdit!: boolean;
  @IsBoolean()
  @Expose()
  canCancel!: boolean;
  @IsBoolean()
  @Expose()
  isLockedForEditByOneOur!: boolean;
  payments!: [] | null;
  @IsBoolean()
  @Expose()
  isCancelled!: boolean;
  formOfPaymentName = null;
  @IsNumber()
  @Expose()
  stateToSend!: number;
  @IsNumber()
  @Expose()
  copyCount!: number;
  @IsBoolean()
  @Expose()
  canIssueDuplicateDocument!: boolean;
  @IsBoolean()
  @Expose()
  isDuplicate!: boolean;
  @IsString()
  @Expose()
  delayPaymentDays!: string;

  @Type(() => ButtonSetting)
  @ValidateNested()
  @Expose()
  buttonSettings!: Map<BUTTON_NAMES, ButtonSetting>;

  @Type(() => RelatedDocument)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  relatedDocuments!: Array<RelatedDocument>;
}

export class DocumentsListResponse extends GenericTableResponse<DocumentsListItem> {
  @Type(() => DocumentsListItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<DocumentsListItem>;
}
